"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Watch = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Watch_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 11a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM14 11a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.5a.997.997 0 0 1-.075.381c.214.14.404.312.562.511.05-.029.104-.06.164-.09A2.995 2.995 0 0 1 8 3c.586 0 1.037.147 1.348.303.06.03.115.06.165.09.158-.2.348-.372.562-.512A.999.999 0 0 1 11 1.5a1 1 0 0 1 .996 1.086c.715.2 1.31.729 1.579 1.447l1.955 5.214A3.5 3.5 0 1 1 9 10.923v-.766A3.73 3.73 0 0 0 8 10c-.34 0-.693.07-1 .157V11A3.5 3.5 0 1 1 .47 9.247l1.955-5.214a2.363 2.363 0 0 1 1.579-1.447A1 1 0 1 1 6 2.5Zm1 6.624C7.306 9.053 7.65 9 8 9s.694.053 1 .124V4.863c0-.196.024-.386.069-.568a1.42 1.42 0 0 0-.168-.098A1.998 1.998 0 0 0 8 4c-.414 0-.713.103-.902.197-.07.035-.126.07-.167.098.045.182.07.372.07.568v4.261Zm-1-.573V4.863a1.363 1.363 0 0 0-2.638-.479L2.08 7.8c.434-.193.914-.3 1.419-.3.98 0 1.865.402 2.5 1.05Zm-.025 2.803a2.522 2.522 0 0 0-.065-1.02 2.501 2.501 0 1 0 .065 1.02ZM10 8.55V4.863a1.363 1.363 0 0 1 2.639-.479l1.28 3.416a3.488 3.488 0 0 0-1.419-.3A3.49 3.49 0 0 0 10 8.55Zm.09 1.783A2.503 2.503 0 0 0 12.5 13.5a2.5 2.5 0 1 0-2.41-3.166Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Watch_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Watch;
exports["default"] = _default;